import { lazy, Suspense } from "react";

// LAS DOS, DIFERIDAS, y es por peso. Entre ellas se traian `RewardModal` y `lib/sound.js`
// -unos cuarenta kilobytes de fuente- al bulto que descarga quien abre la portada por primera
// vez, para enseñar algo que no puede ocurrir hasta que haya hecho algo dentro. La portada
// entera viaja en esa primera carga y rozaba el techo de `check_presupuesto`.
//
// Y NO HAY CARRERA QUE PERDER, que es lo unico que habria que temer al diferir algo que
// escucha un aviso: ninguna de las dos se dispara en el arranque. Las lanza terminar una
// mision o un planeta, o sea segundos largos de interaccion por delante del trozo, que pesa
// poco y empieza a bajar en cuanto se monta esto.
const Felicitacion = lazy(() => import("@/components/Felicitacion"));
const Recompensa = lazy(() => import("@/components/Recompensa"));
// El viaje de la Estrella al entrar en una lección: escucha la dirección, y su escena pesa aparte.
const ViajeEstelar = lazy(() => import("@/components/transicion/ViajeEstelar"));
const AvisoDeReportes = lazy(() => import("@/components/AvisoDeReportes"));

/**
 * Las dos celebraciones de la casa, montadas UNA VEZ en el armazon.
 *
 * POR QUE EN EL ARMAZON Y NO EN CADA PANTALLA. Los cinco segundos de la mision cumplida
 * estaban en el Agora y en el mundo 3D, que es donde se piden las misiones, y eso era una
 * lista de sitios que hay que recordar: en cualquier otra pantalla -el mapa, el panel, una
 * leccion- la felicitacion no salia, y quien buscaba la puerta de prueba en la consola no la
 * encontraba. **Una cosa que puede pasar en cualquier momento se monta donde esta siempre.**
 *
 * SON DOS PIEZAS Y NO UNA porque son dos momentos: la felicitacion no tapa y se va sola; la
 * recompensa tapa y espera a que pulses. Cualquier pantalla las abre llamando a `felicita(...)`
 * de `lib/colaDeFelicitaciones.mjs` o a `celebra(...)` de `lib/recompensa.mjs`; ninguna las
 * monta. Las colas y los avisos viven en esos dos modulos, con sus pruebas.
 */
export default function Celebraciones() {
  return (
    <Suspense fallback={null}>
      <Felicitacion />
      <Recompensa />
      <ViajeEstelar />
      <AvisoDeReportes />
    </Suspense>
  );
}
